import useHotspots from "./Hotspots.hook";

export default useHotspots;
